import { Component } from "react";
import { wp } from "../api/WpApi";
import { Form, Col } from "react-bootstrap";

import Autocomplete from "./AutocompleteResult";

class Search extends Component {
  state = {
    query: "",
    results: [],
    activeIndex: -1,
  };

  clearSearch = () => {
    this.setState({ query: "", results: [] });
    this.search.value = "";
    this.search.setAttribute("aria-expanded", "false");
  };

  handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (this.state.results.length > 0) {
        this.setState({
          activeIndex: (this.state.activeIndex + 1) % this.state.results.length,
        });
      }
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      if (this.state.results.length > 0) {
        this.setState({
          activeIndex:
            (this.state.activeIndex - 1 + this.state.results.length) %
            this.state.results.length,
        });
      }
    } else if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission
      if (
        this.state.activeIndex >= 0 &&
        this.state.results[this.state.activeIndex]
      ) {
        const selected = this.state.results[this.state.activeIndex];
        // navigate to selected post
        this.props.navigate(`/recipes/${selected.slug}/`);
      } else if (this.state.query && this.state.query.length > 1) {
        // fallback: search page
        this.props.navigate(`/search/${encodeURIComponent(this.state.query)}/`);
      }
      this.clearSearch();
    }
  };

  getResult = () => {
    // Fetch pages with search value "xyz": http://wp-api.org/node-wpapi/using-the-client/#api-query-parameters
    wp.posts()
      .search(this.state.query)
      .then((posts) => {
        this.setState({
          isLoading: false,
          results: posts, // Get first element from array
        });
      })
      .catch((error) => {
        this.setState({
          error,
          isLoading: false,
        });
      });
  };

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      () => {
        if (this.state.query && this.state.query.length > 1) {
          this.getResult();
          this.search.setAttribute("aria-expanded", "true");
        } else {
          this.setState({
            results: [],
          });
          this.search.setAttribute("aria-expanded", "false");
        }
      }
    );
  };

  handleInputFocus = () => {
    document.getElementById("autocomplete-result").style.display = "block";
  };

  handleInputBlur = () => {
    setTimeout(function () {
      document.getElementById("autocomplete-result").style.display = "none";
    }, 500);
  };

  render() {
    return (
      <Form>
        <Col xs="auto">
          <Form.Control
            type="text"
            className="post-search-bar"
            placeholder="Search for a recipe..."
            ref={(input) => (this.search = input)}
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            onBlur={this.handleInputBlur}
            onKeyDown={this.handleKeyDown}
            role="combobox"
            aria-owns="autocomplete-result"
            aria-autocomplete="list"
            aria-expanded="false"
            aria-controls="autocomplete-result"
          />
          {this.state.query && (
            <button
              type="button"
              aria-label="Clear search"
              className="clear-search-btn"
              style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                fontSize: "1.2rem",
                color: "#888",
              }}
              onClick={() => {
                this.clearSearch();
              }}
            >
              &#10005;
            </button>
          )}
          <Autocomplete
            results={this.state.results}
            activeIndex={this.state.activeIndex}
          />
        </Col>
      </Form>
    );
  }
}

export default Search;
